import React, { useState, useEffect, useRef } from 'react'
import { Header } from '../../components/Header/Header'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import './CandidateDetails.css'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useParams, Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from 'moment/moment'

export const CandidateDetails = () => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }
  // gfetch username and role from local storage
  const userName = localStorage.getItem('user')
  const role = localStorage.getItem('role')
  const user = localStorage.getItem('user')
  const token = localStorage.getItem('token')

  // useref for auto scroll
  const ref = useRef()

  // onclick event for rescheduling interview
  const handleClick = () => {
    setReschedule(true)
    setFeedback(false)
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: 'smooth' })
    }, 300)
  }

  const handleFeedback = () => {
    setFeedback(true)
    setReschedule(false)
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: 'smooth' })
    }, 300)
  }
  toast.configure()
  const params = useParams()
  const [values, setValues] = useState()
  const [data, setData] = useState({ reason: '', time: '', date: '' })
  const [reschedule, setReschedule] = useState(false)
  const [feedback, setFeedback] = useState(false)
  const [status, setStatus] = useState()
  const [image, setImage] = useState([])
  const [previousData, setPreviousData] = useState([])

  // input onchange
  let name, value
  const handleChange = (e) => {
    name = e.target.name
    value = e.target.value

    setValues({ ...values, [name]: value })
    setData({ ...values, [name]: value })
  }

  // fetching details of candidate
  const getData = async () => {
    await axios
      .post(
        Baseurl.nodeLocal + 'dashboard/fetchFormData',
        {
          id: params.id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        setValues(response.data.currentRoundData[0])
        setPreviousData(response.data.historyData.historyData)
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.eamil])
  // to add feedback and consideration for next round and interviuew screenshot
  const postData = async (e) => {
    e.preventDefault()

    const formData = new FormData()

    const data = {
      nextRoundEmailStatus: true,
      email: values.email,
      applied_date: values.applied_date,
      interviewer_name: values.interviewer_name,
      interview_round: values.interview_round,
      interview_date: values.interview_date,
      interview_time: values.interview_time,
      interview_feedback: values.interview_feedback,
      remarks_hr: values.remarks_hr,
      status_hr: values.status_hr,
      final_status: values.final_status,
      relocate_to_ahmedabad: values.relocate_to_ahmedabad,
      other_offer_on_hand: values.other_offer_on_hand,
      joinig_date: values.joinig_date,
      offered_salary: values.offered_salary,
      offered_bonus: values.offered_bonus,
      final_remarks: values.final_remarks,
      candidate_name: values.candidate_name,
      candidate_linkedin: values.candidate_linkedin,
      contact: values.contact,
      current_ctc: values.current_ctc,
      expected_ctc: values.expected_ctc,
      designation: values.designation,
      relevant_it_experience: values.relevant_it_experience,
      current_organisation: values.current_organisation,
      reason_for_job_change: values.reason_for_job_change,
      reference1_contact: values.reference1_contact,
      reference1_name: values.reference1_name,
      reference2_contact: values.reference2_contact,
      modifierEmail: user,
      eligible_for_next_round: status,
      InterviewerName: user,
      notice_period: values.notice_period,
      reference2_name: values.reference2_name,
    }
    formData.append('data', JSON.stringify(data))
    formData.append('interviewImage', image)

    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/updateFormData',

        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  // to request for rescheduling interview
  const submit = async (e) => {
    e.preventDefault()

    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/rescheduleInterview',

        {
          reason: data.reason,
          new_interview_date: data.date,
          new_interview_time: data.time,
          candidate_name: values.candidate_name,
          position: values.designation,
          interviewer_name: userName,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((res) => {
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          setData({ reason: '', time: '', date: '' })
          setReschedule(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 8000,
        })
        if (error.response.status === 401) {
          toast.error('Your Session Is Not Valid!!', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 8000,
          })
          logout()
        }
      })
  }

  return (
    <>
      {role === 'HR' || role === 'Admin' ? <Sidebar /> : <Header />}

      {values ? (
        <div className="container d-flex justify-content-center align-items-center flex-column">
          <div className="mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={
                      role === 'HR' || role === 'Admin'
                        ? '/home'
                        : '/interviewerDashboard'
                    }
                    className="link text-primary"
                  >
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item">Interview Details</li>
                <li className="breadcrumb-item active" aria-current="page">
                  {values ? values.candidate_name : ''}
                </li>
              </ol>
            </nav>
          </div>
          <div className="mt-3 viewDetails">
            <div className="card border border-0 viewDetailsCard p-4">
              <div className="col-md-12">
                <div className="card-block w-100">
                  <h6 className="m-b-20 p-b-5 b-b-default f-w-600">
                    Information
                  </h6>
                  <div className="row">
                    <div className="col-sm-6 mb-3">
                      <p className="m-b-10 f-w-600">Name</p>
                      <h6 className="text-muted f-w-400">
                        {values.candidate_name}
                      </h6>
                    </div>
                    <div className="col-sm-6">
                      <p className="m-b-10 f-w-600">Designation</p>
                      <h6 className="text-muted f-w-400">
                        {values.designation}
                      </h6>
                    </div>
                    <div className="col-sm-6">
                      <p className="m-b-10 f-w-600">Relavent Experience</p>
                      <h6 className="text-muted f-w-400">
                        {values.relevant_it_experience}
                      </h6>
                    </div>
                    <div className="col-sm-6 mb-3">
                      <p className="m-b-10 f-w-600">Interview Round</p>
                      <h6 className="text-muted f-w-400">
                        {values.interview_round}
                      </h6>
                    </div>
                    <div className="col-sm-6">
                      <p className="m-b-10 f-w-600">Interview Date</p>
                      <h6 className="text-muted f-w-400">
                        {values.interview_date}
                      </h6>
                    </div>
                    <div className="col-sm-6">
                      <p className="m-b-10 f-w-600">Interview Time</p>
                      <h6 className="text-muted f-w-400">
                        {new Date(
                          '1970-01-01T' + values.interview_time + 'Z',
                        ).toLocaleTimeString('en-US', {
                          timeZone: 'UTC',
                          hour12: true,
                          hour: 'numeric',
                          minute: 'numeric',
                        })}
                      </h6>
                    </div>
                  </div>
                  <h6 className="m-b-20 m-t-40 p-b-5 b-b-default f-w-600">
                    Actions
                  </h6>
                  <form onSubmit={postData}>
                    <div className="row">
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">Interview Feedback</h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <textarea
                            type="text"
                            className="form-control"
                            name="interview_feedback"
                            defaultValue={values.interview_feedback}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-3">
                          <h6 className="mb-0">
                            Upload screenshot of interview
                          </h6>
                        </div>
                        <div className="col-sm-9 text-secondary">
                          <input
                            type="file"
                            accept="image/png"
                            className="form-control"
                            onChange={(e) => {
                              if (e.target.files[0] !== undefined) {
                                setImage(e.target.files[0])
                              } else {
                                setImage('')
                              }
                            }}
                          />
                          <h6>*png</h6>
                        </div>
                      </div>
                      <div className="row mb-3">
                        <div className="col-sm-9">
                          <h6 className="mb-0">
                            Can we consider the candidate for the next round?
                          </h6>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio1"
                              value="option1"
                              onChange={() => setStatus(true)}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inlineRadio1"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="inlineRadioOptions"
                              id="inlineRadio2"
                              value="option2"
                              onChange={() => setStatus(false)}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor="inlineRadio2"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <ul class="social-link list-unstyled m-t-40 m-b-10  row">
                      <li className="col-md">
                        <button className="btn btn-primary" type="submit">
                          Update
                        </button>
                      </li>
                      <li
                        className="col-md  d-flex justify-content-start"
                        style={{ width: '200px' }}
                      >
                        <a
                          href={values.candidate_resume}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <button
                            className="btn btn-outline-primary"
                            type="button"
                            style={{ marginLeft: '1rem' }}
                          >
                            View Resume
                          </button>
                        </a>
                      </li>
                      <li className="col-md-5 d-flex justify-content-end">
                        <button
                          className="btn btn-outline-primary"
                          style={{ marginLeft: '1rem' }}
                          ref={ref}
                          onClick={handleClick}
                          type="button"
                        >
                          Reschedule Interview
                        </button>
                      </li>
                    </ul>
                    <div className="d-flex justify-content-end">
                      <h6
                        style={{ cursor: 'pointer' }}
                        className="text-primary"
                        onClick={handleFeedback}
                      >
                        View Previous Interview Feedback ?
                      </h6>
                    </div>
                  </form>
                </div>

                {reschedule === true ? (
                  <div className="p-4" ref={ref}>
                    <form onSubmit={submit}>
                      <div className="m-b-20 m-t-40 p-b-5 b-b-default f-w-600 d-flex justify-content-between">
                        <h6>Reschedule Interview</h6>
                        <h6
                          style={{ cursor: 'pointer' }}
                          onClick={() => setReschedule(false)}
                        >
                          X
                        </h6>
                      </div>

                      <div className="row">
                        <div className="row mb-3">
                          <div className="col-sm-3">
                            <h6 className="mb-0">Reason For Reschedule</h6>
                          </div>
                          <div className="col-sm-9 text-secondary">
                            <input
                              type="text"
                              className="form-control"
                              name="reason"
                              value={data.reason}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <h6 class="m-b-20 p-b-5 b-b-default f-w-600 mt-3">
                        Select Reschedule time and date
                      </h6>
                      <div class="row">
                        <div class="col-sm-6 mb-3">
                          <p class="m-b-10 f-w-600">Reschedule Time</p>
                          <input
                            type="time"
                            className="form-control"
                            name="time"
                            value={data.time}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div class="col-sm-6">
                          <p class="m-b-10 f-w-600">Reschedule Date</p>
                          <input
                            type="date"
                            className="form-control"
                            name="date"
                            value={data.date}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button className="btn btn-primary">
                          Submit Request
                        </button>
                      </div>
                    </form>
                  </div>
                ) : feedback ? (
                  <div className="p-4" ref={ref}>
                    <div className="m-b-20 m-t-40 p-b-5 b-b-default f-w-600 d-flex justify-content-between">
                      <h6>Previous Interview Feedback</h6>
                      <h6
                        style={{ cursor: 'pointer' }}
                        onClick={() => setFeedback(false)}
                      >
                        X
                      </h6>
                    </div>
                    {previousData?.map((i, index) => {
                      if (
                        i.interview_feedback !== null &&
                        i.interview_feedback !== ''
                      ) {
                        return (
                          <>
                            <div className="row  mt-2" key={index}>
                              <div className="col-md-3">
                                <h6 className="mt-1 text-muted">
                                  Interiew Round
                                </h6>
                              </div>
                              <div className="col-md-8 mx-2 d-flex justify-content-start">
                                {i.interview_round}
                              </div>
                            </div>
                            <div className="row  mt-2">
                              <div className="col-md-3">
                                <h6 className="mt-1 text-muted">
                                  Interiew Feedback
                                </h6>
                              </div>
                              <div className="col-md-8 mx-2 d-flex justify-content-start">
                                {i.interview_feedback}
                              </div>
                            </div>
                            <div className="row  mt-2">
                              <div className="col-md-3">
                                <h6 className="mt-1 text-muted">Interiewer</h6>
                              </div>
                              <div className="col-md-8 mx-2 d-flex justify-content-start">
                                {i.interviewer_name}
                              </div>
                            </div>
                            <div className="row  mt-2">
                              <div className="col-md-3">
                                <h6 className="mt-1 text-muted">
                                  Interiew Date
                                </h6>
                              </div>
                              <div className="col-md-8 mx-2 d-flex justify-content-start">
                                {moment(i.interview_date).format('DD-MM-YYYY')}
                              </div>
                            </div>
                            <hr />
                          </>
                        )
                      }
                      return false
                    })}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}
